import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Tag } from 'antd';
import { 
  NumberOutlined, 
  FontSizeOutlined, 
  CalendarOutlined,
  DatabaseOutlined 
} from '@ant-design/icons';

const DraggableField = ({ field }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({
    id: field.name,
    data: {
      field: field
    }
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    opacity: isDragging ? 0.5 : 1,
  } : undefined;

  const getFieldIcon = (type) => {
    switch (type) {
      case 'number':
      case 'integer':
      case 'float':
        return <NumberOutlined />;
      case 'string':
      case 'text':
        return <FontSizeOutlined />;
      case 'date':
      case 'datetime':
        return <CalendarOutlined />;
      default:
        return <DatabaseOutlined />;
    }
  };

  const getFieldColor = (type) => {
    switch (type) {
      case 'number':
      case 'integer':
      case 'float':
        return 'green';
      case 'string':
      case 'text':
        return 'blue';
      case 'date':
      case 'datetime':
        return 'orange';
      default:
        return 'default';
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className="draggable-field"
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {getFieldIcon(field.type)}
        {field.name}
      </span>
      <Tag color={getFieldColor(field.type)} size="small">
        {field.type}
      </Tag>
    </div>
  );
};

export default DraggableField;